/**
 * 建築タイプグループを SingleSelectionArchitecture（特別カード）で表示すべきか。
 *
 * Selection series（リノベ単棟）かつ部屋タイプが 1 種類のとき true。
 * Selection でも部屋タイプが複数なら通常の ArchitectureTypeGroup（false）。
 */
export function isSingleSelection(
  roomTypes: { architectureType?: { series?: string | null } | null }[],
): boolean {
  return (
    roomTypes.length === 1 &&
    roomTypes[0]?.architectureType?.series === "Selection"
  );
}
